import { trackEvent } from '@/utils/tracking/countly';

export const trackClosingModal = (modalName: string): void => {
  trackEvent({ key: 'Closed modal', segmentation: { modal: modalName } });
};
